import {
  Alert,
  AppContext,
  CancelRider,
  CancelRiderFromInceptionService,
  CancelRiderService,
  Checkbox,
  CheckboxTable,
  CheckboxTableColum,
  ErrorHandling,
  formatNumberWithComma,
  GeneralInfoService,
  HCR9BenefitInformationModal,
  HCR9BenefitInformationResponse,
  Panel,
  PulseOpsFormat,
  RoundedButton,
  SelectedRowProps,
  sharedStyle,
  SortFieldInfo,
  Title,
  TransactionType
} from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, SafeAreaView, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import * as O from 'fp-ts/lib/Option'
import { PolicyServiceProps } from '../policy-service-props'
import { Controller, FieldArrayWithId, useFieldArray, useForm } from 'react-hook-form'
import { CancelRiderFormData } from './cancel-rider.form'
import { useLoading } from '@mxt/zio-react'
import { useIsFocused } from '@react-navigation/native'
import { Error } from '@pulseops/submission/common'
import moment from 'moment'
import { RequestAuthenticateData } from '../../request-authen'

export const CancelRiderScreen: React.FC<PolicyServiceProps<CancelRider.SubmitCancelRiderData>> = (props) => {
  const { t, i18n } = useTranslation()
  const policyNum = props.policyNumber ?? ''

  const isFocused = useIsFocused()
  const [isLoading, bindLoader] = useLoading(false)
  const { showGlobalLoading, showToast } = React.useContext(AppContext.AppContextInstance)
  const [detailData, setDetailData] = React.useState<CancelRider.DetailCancelRiderInfo>()
  const [estimatedPremiumFlag, setEstimatedPremiumFlag] = React.useState<boolean>(false)
  const [errorMsg, setErrorMsg] = React.useState<string>('')
  const [customerReceivedDateOfRider, setCustomerReceivedDateOfRider] = React.useState<CancelRiderFromInceptionService.CustomerReceiveDateOfRiderResponse[]>([])
  const [effectiveDateDropRider, setEffectiveDateDropRider] = React.useState<string>('')
  const [sortItem, setSortItem] = React.useState<SortFieldInfo>({
    field: '',
    order: 'asc'
  })
  const [isOpenHCR9BenefitModal, setIsOpenOpenHCR9BenefitModal] = React.useState(false)
  const [HCR9BenefitInformation, setHCR9BenefitInformation] = React.useState<HCR9BenefitInformationResponse[]>([])

  const cancelRiderForm = useForm<CancelRiderFormData.CancelAllRiderForm>({
    defaultValues: {
      cancelAllRider: false,
      LARiderForm: [],
      reEstimatedInstallPremium: 0
    }
  })
  const cancelRiderFormArray = useFieldArray({
    control: cancelRiderForm.control,
    name: 'LARiderForm'
  })

  const displayedBenefitColumns: CheckboxTableColum[] = [
    {
      title: t('PRUFlexiHealthBenefit:Benefit'),
      fieldName: 'benefitName',
      disabled: true,
      rowRender: (selectedRow) => {
        const benefitName = selectedRow.selectItem["benefitName"] as string
        const benefitCode = selectedRow.selectItem["benefitCode"] as string
        const customedName = i18n.language === 'en' ? benefitCode : benefitName
        return <Text>{customedName}</Text>
      }
    },
    {
      title: t('claim:SumAssured'),
      fieldName: 'sumInsurance',
      disabled: true,
      rowRender: (selectedRow) => {
        const sumInsurance = selectedRow.selectItem["sumInsurance"] as number
        return <Text>{PulseOpsFormat.thousandSepartor(sumInsurance)}</Text>
      }
    },
    {
      title: t('PRUFlexiHealthBenefit:Copay'),
      fieldName: 'coPay',
      disabled: true
    },
    {
      title: t('requestInfo:InstallmentPremium'),
      fieldName: 'installPremium',
      disabled: true,
      rowRender: (selectedRow) => {
        const installPremium = selectedRow.selectItem["installPremium"] as number
        return <Text>{PulseOpsFormat.thousandSepartor(installPremium)}</Text>
      }
    },

  ]

  React.useEffect(() => {
    if (isFocused && policyNum) {
      pipe(
        ZIO.zipPar(
          CancelRiderService.getDetail(policyNum),
          CancelRiderFromInceptionService.getCustomerReceivedDateOfRider(policyNum),
          CancelRiderFromInceptionService.getEffectiveDateDropRiderOfProduct(policyNum)
        ),
        ZIO.map(([responseData, receivedDatesOfRider, effectiveDateDropRiderOfProduct]) => {
          let LARiderFormArray: Array<CancelRiderFormData.RiderForm> = []
          setDetailData(responseData)
          setCustomerReceivedDateOfRider(receivedDatesOfRider)
          setEffectiveDateDropRider(effectiveDateDropRiderOfProduct)
          const LARiderItemList = responseData.laRiderInfo
          LARiderItemList.map((LAItem) => {
            LAItem.riders.map((rider) => {
              const riderInfoItem = responseData.riderNameList.find((x) => x.code === rider.productCode)
              rider.productName = getRiderName(riderInfoItem, i18n.language)
              LARiderFormArray.push({
                riderCode: rider.productCode,
                riderName: rider.productName,
                SelectRowForRider: false,
                riskCommDate: rider.riskCommDate,
                riskCessDate: rider.riskCessDate,
                sumAssured: rider.sumAssured,
                installmentPrem: rider.installmentPrem,
                newInstallmentPremium: 0,
                lifeNo: rider.lifeNo,
                coverageNo: rider.coverageNo,
                riderNo: rider.riderNo,
                riderStatus: rider.riderStatus
              })
            })
            cancelRiderFormArray.append({
              selectAllForLA: false,
              LAName: LAItem.clientName,
              lifeAssured: LAItem.lifeAssured,
              cancelRiderForm: LARiderFormArray
            })
            // LARiderFormArray.remove()
            LARiderFormArray = []
          })
        }),
        bindLoader,
        ErrorHandling.run()
      )
    }
    return () => {
      cancelRiderFormArray.remove()
      setDetailData(undefined)
      setEstimatedPremiumFlag(false)
      setErrorMsg('')
      setCustomerReceivedDateOfRider([])
      setEffectiveDateDropRider('')
      cancelRiderForm.reset({
        cancelAllRider: false,
        LARiderForm: [],
        reEstimatedInstallPremium: 0
      })
    }
  }, [isFocused])

  React.useEffect(() => {
    showGlobalLoading(isLoading)
  }, [isLoading])

  const getRiderDisplayedColumns = (index: number, fieldItem: FieldArrayWithId<CancelRiderFormData.CancelAllRiderForm, "LARiderForm", "id">) => {
    return [
      {
        title: '',
        fieldName: '',
        disabled: true,
        headerColumnRender: (_: any) => {
          return (
            <Controller
              control={cancelRiderForm.control}
              name={`LARiderForm.${index}.selectAllForLA`}
              render={({ field: { onChange, onBlur, value } }) => (
                <Checkbox
                  onChange={(checked) => {
                    onChange(checked)
                    onAllRiderSelectedEventForLA(checked, index, fieldItem)
                  }}
                  onBlur={onBlur}
                  value={value}
                  disabled={props.isConfirmed}
                  checkBoxStyle={cancelRiderStyles.tableCheckBox}
                />
              )}
            />
          )
        },
        rowRender: (selectedRow: SelectedRowProps) => {
          const subIndex = selectedRow.index
          const riderInfo = fieldItem.cancelRiderForm[subIndex]
          return (
            <Controller
              control={cancelRiderForm.control}
              name={`LARiderForm.${index}.cancelRiderForm.${subIndex}.SelectRowForRider`}
              render={({ field: { onChange, onBlur, value } }) => (
                <Checkbox
                  onChange={(val) => {
                    onChange(val)
                    changeEventForRider(riderInfo, val)
                  }}
                  onBlur={onBlur}
                  value={value}
                  disabled={props.isConfirmed}
                  checkBoxStyle={cancelRiderStyles.tableCheckBox}
                />
              )}
            />
          )
        }
      },
      {
        title: t('requestInfo:RiderName'),
        fieldName: 'riderName',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riderCode = selectedRow.selectItem["riderCode"] as string
          const riderName = selectedRow.selectItem["riderName"] as string
          const lifeNo = selectedRow.selectItem["lifeNo"] as string
          const isHCR9Product = riderCode === 'HCR9'
          return isHCR9Product ? (
            <TouchableOpacity onPress={() => onOpenHCR9BenefitModal(lifeNo)}>
              <Text style={cancelRiderStyles.underlineLink}>{riderName}</Text>
            </TouchableOpacity>
          ) : <Text>{riderName}</Text>
        }
      },
      {
        title: t('CancelRider:RiskCommencementDate'),
        fieldName: 'riskCommDate',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riskCommDate = selectedRow.selectItem["riskCommDate"] as string
          return <Text>{convertStringToDateString(riskCommDate)}</Text>
        }
      },
      {
        title: t('requestInfo:RiskCessationDate'),
        fieldName: 'riskCessDate',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riskCessDate = selectedRow.selectItem["riskCessDate"] as string
          return <Text>{convertStringToDateString(riskCessDate)}</Text>
        }
      },
      {
        title: t('requestInfo:SumAssured'),
        fieldName: 'sumAssured',
        disabled: true,
        rowRender: (selectedRow: SelectedRowProps) => {
          const riderCode = selectedRow.selectItem["riderCode"] as string
          const sumAssured = selectedRow.selectItem["sumAssured"] as number
          const isHCR9Product = riderCode === 'HCR9'
          return <Text>{isHCR9Product ? '-' : convertNumberToCurrencyFormat(sumAssured)}</Text>
        }
      },
      {
        title: t('CancelRider:InstallmentPremium'),
        fieldName: 'installmentPrem',
        rowRender: (selectedRow: SelectedRowProps) => {
          const installmentPrem = selectedRow.selectItem["installmentPrem"] as number
          return <Text>{convertNumberToCurrencyFormat(installmentPrem)}</Text>
        }
      },
    ]
  }

  const onOpenHCR9BenefitModal = (lifeNo: string) => {
    if (!!policyNum) {
      pipe(
        GeneralInfoService.getBenefitInformationForHCR9(policyNum),
        ZIO.fold(
          (error) => {
            setHCR9BenefitInformation([])
            setIsOpenOpenHCR9BenefitModal(true)
          },
          (response) => {
            const HCR9BenefitList = response.filter((item) => item.lifeNo === lifeNo && item.sumInsurance > 0 && item.installPremium > 0)
            setHCR9BenefitInformation(HCR9BenefitList)
            setIsOpenOpenHCR9BenefitModal(true)
          }
        ),
        ZIO.unsafeRun({})
      )
    }
  }

  const onCloseHCR9BenefitModal = () => {
    setIsOpenOpenHCR9BenefitModal(false)
  }

  const getRiderName = (item: any, isEN = 'en') => {
    return !!item ? (isEN === 'en' ? item.name : item.nameVi) : ''
  }

  const convertDateStringForSubmit = (strDate: string) => {
    return moment(strDate).format('YYYY-MM-DD')
  }

  const convertNumberToCurrencyFormat = (value: number) => {
    return formatNumberWithComma(value)
  }

  const convertStringToDateString = (strDate: string) => {
    return moment(strDate).format('DD/MM/YYYY')
  }

  const getTotalSelectedPremium = () => {
    let totalPremium: number = 0
    cancelRiderFormArray.fields.forEach((fieldItem) => {
      const riderTotal = fieldItem.cancelRiderForm.reduce((total, riderItem) => {
        return riderItem.SelectRowForRider ? total + riderItem.installmentPrem : total
      }, 0)
      totalPremium += riderTotal
    })
    console.log('totalSelectedInstallPremium: ' + totalPremium)
    return totalPremium
  }

  // only calculate one time when user click first time
  const calculateEstimatedInstallPremium = () => {
    let totalSelectedInstallPremium: number = getTotalSelectedPremium()
    setEstimatedPremiumFlag(true)
    const estimatedPremium = (detailData?.totalPremium ?? 0) - totalSelectedInstallPremium
    cancelRiderForm.setValue('reEstimatedInstallPremium', estimatedPremium)
    if (estimatedPremium < (detailData?.minPremium ?? 0)) {
      // showToast(t(`message:MS050014`), 'error')
      showToast(t(`message:MS050054`, { min: formatNumberWithComma(detailData?.minPremium ?? 0) }), 'error')
      cancelRiderForm.setValue('reEstimatedInstallPremium', 0)
    } else if (estimatedPremium <= 0) {
      showToast(t(`message:MS050034`), 'error')
      cancelRiderForm.setValue('reEstimatedInstallPremium', 0)
    }
  }

  //calculate again when user checked or unchecked rider
  const reCalculateEstimatedInstallPremium = (riderPremium: number, selectedRow: boolean) => {
    let reEstimatedInstallPremiumVal: number = 0
    let totalSelectedInstallPremium: number = 0
    if (estimatedPremiumFlag) {
      const ReEstimatePremium = cancelRiderForm.watch('reEstimatedInstallPremium')
      totalSelectedInstallPremium = Number(detailData?.totalPremium ?? 0) - ReEstimatePremium
      if (selectedRow) {
        reEstimatedInstallPremiumVal =
          Number(detailData?.totalPremium ?? 0) - (totalSelectedInstallPremium + riderPremium)
        cancelRiderForm.setValue('reEstimatedInstallPremium', reEstimatedInstallPremiumVal)
      } else {
        reEstimatedInstallPremiumVal =
          Number(detailData?.totalPremium ?? 0) - (totalSelectedInstallPremium - riderPremium)
        cancelRiderForm.setValue('reEstimatedInstallPremium', reEstimatedInstallPremiumVal)
      }
      if (reEstimatedInstallPremiumVal < Number(detailData?.minPremium)) {
        // showToast(t(`message:MS050014`), 'error')
        showToast(t(`message:MS050054`, { min: formatNumberWithComma(detailData?.minPremium ?? 0) }), 'error')
        cancelRiderForm.setValue('reEstimatedInstallPremium', 0)
      } else if (reEstimatedInstallPremiumVal <= 0) {
        showToast(t(`message:MS050034`), 'error')
        cancelRiderForm.setValue('reEstimatedInstallPremium', 0)
      }
    }
  }

  const onAllRiderSelectedEventForLA = (
    checkedAllLA: boolean,
    LAIndex: number,
    fieldItem: FieldArrayWithId<CancelRiderFormData.CancelAllRiderForm, 'LARiderForm', 'id'>
  ) => {
    if (checkedAllLA) {
      fieldItem.cancelRiderForm.forEach((subField, subIndex) => {
        const selectedElement = subField.SelectRowForRider
        if (!selectedElement) {
          cancelRiderForm.setValue(`LARiderForm.${LAIndex}.cancelRiderForm.${subIndex}.SelectRowForRider`, true)
          // reCalculateEstimatedInstallPremium(subField.installmentPrem, true)
          changeEventForRider(subField, true)
        }
      })
    } else {
      fieldItem.cancelRiderForm.forEach((subField, subIndex) => {
        const selectedElement = subField.SelectRowForRider
        if (selectedElement) {
          cancelRiderForm.setValue(`LARiderForm.${LAIndex}.cancelRiderForm.${subIndex}.SelectRowForRider`, false)
          // reCalculateEstimatedInstallPremium(subField.installmentPrem, false)
          changeEventForRider(subField, false)
        }
      })
    }
  }

  const changeEventForRider = (riderInfo: CancelRiderFormData.RiderForm, isChecked: boolean) => {
    reCalculateEstimatedInstallPremium(riderInfo.installmentPrem, isChecked)
    if (isChecked && ["HCR1", "HCR2", "HCR3", "HCR9", "HSR1", "HSR4", "HSR9"].includes(riderInfo.riderCode)) {
      const paidToDateBasic = pipe(
        O.fromNullable(detailData?.policyInfoData?.paidToDateBasic),
        O.map((paidToDate) => paidToDate),
        O.getOrElse(() => '')
      )
      const paidToDateRider = pipe(
        O.fromNullable(detailData?.policyInfoData?.paidToDateRider),
        O.map((paidToDateData) => paidToDateData),
        O.getOrElse(() => '')
      )
      const paidToDate = !!paidToDateRider ? paidToDateRider : paidToDateBasic
      if (moment(paidToDate).subtract(30, 'days').isAfter(moment(new Date(), 'YYYYMMDD'))) {
        pipe(
          Alert.alertM(t('message:MS020138'), 'Warning', t('submission:Continue')),
          ZIO.unsafeRun({})
        )
      }
    }
  }

  const onCancelAllRiderCheckedEvent = (value: boolean) => {
    cancelRiderFormArray.fields.map((fieldItem, index) => {
      cancelRiderForm.setValue(`LARiderForm.${index}.selectAllForLA`, value)
      onAllRiderSelectedEventForLA(value, index, fieldItem)
    })
  }

  const isCheckedValidRider = () => {
    let invalidFlag: boolean = false
    cancelRiderFormArray.fields.forEach((fieldItem) => {
      fieldItem.cancelRiderForm.forEach((riderItem) => {
        if (riderItem.SelectRowForRider) {
          invalidFlag = true
        }
      })
    })
    return invalidFlag
  }

  const validateSubmitData = () => {
    const ReEstimatePremium = cancelRiderForm.watch('reEstimatedInstallPremium')
    if (!isCheckedValidRider()) {
      setErrorMsg(t('message:MS050234'))
      return false
    } else if (ReEstimatePremium < Number(detailData?.minPremium ?? 0)) {
      // showToast(t(`message:MS050014`), 'error')
      showToast(t(`message:MS050054`, { min: formatNumberWithComma(detailData?.minPremium ?? 0) }), 'error')
      return false
    } else if (ReEstimatePremium <= 0) {
      showToast(t(`message:MS050034`), 'error')
      return false
    } else if (['VLR9', 'ULR9', 'VLM1', 'TLA9', 'EUS5'].includes(detailData?.coverageCode || '')) {
      const hasRiderInvalidCondition1 = cancelRiderFormArray.fields
        .some((fieldItem) => fieldItem.cancelRiderForm
          .filter((rider) => rider.SelectRowForRider).some((rider) => {
            const isInvalidRider = pipe(
              O.fromNullable(
                customerReceivedDateOfRider.find((p) =>
                  !!p.customerReceivedDate &&
                  p.coverageCode === rider.riderCode &&
                  p.lifeNo === rider.lifeNo &&
                  p.coverageNo === rider.coverageNo &&
                  p.riderNo === rider.riderNo
                )
              ),
              O.fold(
                () => false,
                (receivedDateItem) => {
                  if (moment(rider.riskCommDate).valueOf() !== moment(detailData?.riskCommenceDate).valueOf()
                    && moment(receivedDateItem.tf57TransactionDate).isAfter(moment(effectiveDateDropRider))
                    && (moment(new Date()).startOf('day').diff(moment(receivedDateItem.customerReceivedDate).startOf('day'), 'days') <= 21)
                  ) {
                    return true
                  } else {
                    return false
                  }
                }
              )
            )
            return isInvalidRider
          }))
      const hasRiderInvalidCondition2 = cancelRiderFormArray.fields
        .some((fieldItem) => fieldItem.cancelRiderForm
          .filter((rider) => rider.SelectRowForRider).some((rider) => {
            const isInvalidRider = pipe(
              O.fromNullable(
                customerReceivedDateOfRider.find((p) =>
                  p.coverageCode === rider.riderCode &&
                  p.lifeNo === rider.lifeNo &&
                  p.coverageNo === rider.coverageNo &&
                  p.riderNo === rider.riderNo
                )
              ),
              O.fold(
                () => {
                  return false
                },
                (customerReceivedDateItem) => {
                  if (moment(rider.riskCommDate).valueOf() !== moment(detailData?.riskCommenceDate).valueOf()
                    && moment(customerReceivedDateItem.tf57TransactionDate).isAfter(moment(effectiveDateDropRider))
                    && customerReceivedDateItem.customerReceivedDate === ''
                  ) {
                    return true
                  } else {
                    return false
                  }
                }
              )
            )
            return isInvalidRider
          }))
      if (hasRiderInvalidCondition1) {
        showToast(t(`message:MS020123`), 'error')
        return false
      } else if (hasRiderInvalidCondition2) {
        showToast(t(`message:MS020122`), 'error')
        return false
      } else {
        setErrorMsg('')
        return true
      }
    } else {
      setErrorMsg('')
      return true
    }
  }

  const mappingData = (): CancelRider.SubmitCancelRiderData => {
    let mappingCancelRiderData: CancelRider.SubmitLARider[] = cancelRiderFormArray.fields.map((fieldItem) => {
      const riderListForEachLA: CancelRider.SubmitedRiderInfo[] = fieldItem.cancelRiderForm
        .filter((x) => x.SelectRowForRider)
        .map((subItem) => {
          const riskCommDate = convertDateStringForSubmit(subItem.riskCommDate)
          const riskCessDate = convertDateStringForSubmit(subItem.riskCessDate)
          const newInstallmentPremium = Number(detailData?.totalPremium ?? '') - subItem.installmentPrem
          return {
            productCode: subItem.riderCode,
            riskCommDate: riskCommDate,
            riskCessDate: riskCessDate,
            sumAssured: subItem.sumAssured,
            installmentPremium: subItem.installmentPrem,
            newInstallmentPremium: newInstallmentPremium,
            lifeNo: subItem.lifeNo,
            coverageNo: subItem.coverageNo,
            riderNo: subItem.riderNo,
            status: subItem.riderStatus
          }
        })
      return {
        lifeAssured: fieldItem.lifeAssured,
        riders: riderListForEachLA
      }
    })
    return {
      lifeAssureds: mappingCancelRiderData.filter((x) => !!x && x.riders.length > 0)
    }
  }

  props.initSubmission({
    validate: async () => {
      if (validateSubmitData()) {
        const submitedData = mappingData()
        // console.log(`submitedData: ${JSON.stringify(submitedData)}`)
        return {
          url: (policyNum: string) => `wf-api/policy/${policyNum}/cancel-rider/submission-for-staff`,
          body: submitedData,
          transactionName: RequestAuthenticateData.TransactionLabelShort(TransactionType.CANCEL_RIDER),
          collerationId: policyNum,
          transaction: TransactionType.CANCEL_RIDER
        }
      } else {
        return false
      }
    },
    clear: () => {
      cancelRiderForm.setValue('cancelAllRider', false)
      onCancelAllRiderCheckedEvent(false)
    }
  })

  return (
    <SafeAreaView style={{ flex: 1, marginTop: 15 }}>
      <View>
        <Title title={t('CancelRider:RIDERLIST')}></Title>
        <Controller
          control={cancelRiderForm.control}
          name="cancelAllRider"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              title={t('CancelRider:CancelAllRider')}
              value={value}
              onChange={(val) => {
                onChange(val)
                onCancelAllRiderCheckedEvent(val)
              }}
              onBlur={onBlur}
              // checkBoxStyle={{marginBottom:20}}
              disabled={props.isConfirmed}
            />
          )}
        />
        {cancelRiderFormArray.fields.map((fieldItem, index) => (
          <Panel title={fieldItem.LAName} key={fieldItem.id} isNoPadding={true} isTransactionToggleExpand={true}>
            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: 20 }}>
              <Text style={{ fontStyle: 'italic' }}>{t('requestInfo:Currency')}: VND</Text>
            </View>
            <CheckboxTable
              displayedColumns={getRiderDisplayedColumns(index, fieldItem)}
              dataSource={cancelRiderForm.watch(`LARiderForm.${index}.cancelRiderForm`).map((item) => ({
                riderCode: item.riderCode,
                riderName: item.riderName,
                lifeNo: item.lifeNo,
                riskCommDate: item.riskCommDate,
                riskCessDate: item.riskCessDate,
                sumAssured: item.sumAssured,
                installmentPrem: item.installmentPrem,
              }))}
              containerStyle={sharedStyle.tableWrapper}
              sortItem={sortItem}
              setSortItem={setSortItem}
              isBorderedTable={false}
            />
          </Panel>
        ))}
        <View>
          {!props.isConfirmed && (
            <RoundedButton
              showBorder={false}
              filled={true}
              activeOpacity={0.7}
              text={t('CancelRider:CalculatePremium')}
              textStyle={cancelRiderStyles.btnText}
              style={{ height: 39, paddingHorizontal: 20 }}
              textColorDisable="#FFFFFF"
              textColorEnable="#FFFFFF"
              bgColorDisable={'#B0B0B0'}
              bgColorEnable={'#ED1B2E'}
              borderColorDisable={'#B0B0B0'}
              borderColorEnable={'#ED1B2E'}
              onPress={calculateEstimatedInstallPremium}
            />
          )}
          <View style={cancelRiderStyles.estimatedPremiumBtn}>
            <Text>{t('CancelRider:EstimatedNewInstallmentPremium')}</Text>
            {cancelRiderForm.watch('reEstimatedInstallPremium') > 0 && (
              <Text style={cancelRiderStyles.red_line}>
                {convertNumberToCurrencyFormat(cancelRiderForm.watch('reEstimatedInstallPremium'))} VND
              </Text>
            )}
          </View>
          <View style={cancelRiderStyles.estimatedPremiumBtn}>{!!errorMsg && <Error message={errorMsg} />}</View>
        </View>
      </View>
      <HCR9BenefitInformationModal
        isOpen={isOpenHCR9BenefitModal}
        modalTitle={t('PRUFlexiHealthBenefit:DropRiderDetailPanel')}
        HCR9BenefitInformation={HCR9BenefitInformation}
        displayedColumns={displayedBenefitColumns}
        handleClose={onCloseHCR9BenefitModal}
      />
    </SafeAreaView>
  )
}
const cancelRiderStyles = StyleSheet.create({
  btnText: {
    fontSize: 14
  },
  red_line: {
    color: '#ed1c2e',
    fontSize: 15,
    fontWeight: '700'
  },
  estimatedPremiumBtn: {
    marginTop: 15
  },
  tableHeaderText: {
    fontSize: 15,
    fontWeight: '700'
  },
  TableColText: {
    fontSize: 15
  },
  tableCheckBox: {
    padding: 0,
    marginTop: 0,
    paddingLeft: 10
  },
  underlineLink: {
    color: 'blue',
    textDecorationLine: 'underline'
  }
})
